export default __webpack_public_path__ + "static/media/Lightsaber Obi-Wan ANH - Img - Wip 11_06.e6c16832.jpg";